import client from 'api/apiClient';
import { oldGloryBaseUrl } from 'config/apiConfig';
import { store } from 'redux/store';
import { getDefaultCompanyId } from 'utils/helpers';

export const fetchUserEntities = async () => {
    try {
        const response: any = await client.get('/user/getUserEntities');
        return response?.user;
    } catch (error) {
        console.error('Error getting data:', error);
    }
};

export const fetchPersonalUser = async (stringToFind: string) => {
    if (!stringToFind) return;
    const state: any = store.getState();
    const companyId = getDefaultCompanyId(state);
    try {
        const response: any = await client.get(`${oldGloryBaseUrl}/user/getUserByString`, {
            params: { stringToFind },
            headers: {
                companyId,
            },
        });
        return response?.users;
    } catch (error) {
        console.error('Error getting data:', error);
    }
};

export const fetchMerchantUser = async (stringToFind: string) => {
    if (!stringToFind) return;
    const state: any = store.getState();
    const companyId = getDefaultCompanyId(state);
    try {
        const response: any = await client.get(`${oldGloryBaseUrl}/user/getMerchantByString`, {
            params: { stringToFind },
            headers: {
                companyId,
            },
        });
        return response?.users;
    } catch (error) {
        console.error('Error getting data:', error);
    }
};
